import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  async connect() {
    if (this.choices) return

    const { default: Choices } = await import("choices.js")
    if (!this.element.isConnected) return

    this.choices = new Choices(this.selectTarget, {
      allowHTML: false,
      itemSelectText: "",
      removeItemButton: false,
      searchEnabled: true,
      searchPlaceholderValue: "Type to search",
      shouldSort: false
    })
  }

  disconnect() {
    if (!this.choices) return

    this.choices.destroy()
    this.choices = null
  }
}
